import BookmarkButton from './bookmark-button';

import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import InfoOutlined from '@mui/icons-material/InfoOutlined';

export default function TitleWithBookmark({
  title,
  bookmarkKey,
  showBookmark = true,
  infoTooltip,
}: Readonly<{
  title: string;
  bookmarkKey: string;
  showBookmark?: boolean;
  infoTooltip?: string;
}>) {
  return (
    <Stack
      sx={{
        mb: 1,
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
      }}
      gap={0.5}
    >
      <Stack direction="row" spacing={0.5} alignItems="center">
        <Typography sx={{ fontWeight: 300, fontSize: '2rem' }}>
          {title}
        </Typography>
        {showBookmark && <BookmarkButton bookmarkKey={bookmarkKey} />}
      </Stack>
      {infoTooltip && (
        <Tooltip title={infoTooltip}>
          <IconButton size="small">
            <InfoOutlined />
          </IconButton>
        </Tooltip>
      )}
    </Stack>
  );
}
